import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { theme, useBreakpointHelpers } from '@sweetgreen/garnish';

export const AccountScreenBorderedSection = ({
  children,
  style,
}: ViewProps) => {
  const { isMobile } = useBreakpointHelpers();

  return (
    <View
      testID="account.bordered-section"
      style={[!isMobile && styles.container, style]}
    >
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: theme.radius.large,
    borderColor: theme.colors.GRAY,
    borderStyle: 'solid',
    borderWidth: 1,
    paddingHorizontal: theme.spacing.large,
  },
});
